import {
  Development,
  English,
  EnglishAustralia,
  EnglishUnitedKingdom,
  French,
  FrenchCanada,
  German,
  Spanish,
} from './locale-context-provider/locale-codes';

export const localeData = {
  [English]: () => import('../locales/compiled/en.json'),
  [EnglishAustralia]: () => import('../locales/compiled/en-AU.json'),
  [EnglishUnitedKingdom]: () => import('../locales/compiled/en-GB.json'),
  [Development]: () => import('../locales/compiled/en-XA.json'),
  [Spanish]: () => import('../locales/compiled/es.json'),
  [French]: () => import('../locales/compiled/fr.json'),
  [FrenchCanada]: () => import('../locales/compiled/fr-CA.json'),
  [German]: () => import('../locales/compiled/de.json'),
};
